import "@amir04lm26/react-modern-calendar-date-picker/lib/DatePicker.css";
import ModernDatePicker, { DayValue } from "@amir04lm26/react-modern-calendar-date-picker";
import styles from './style.module.scss';

interface Props {
    label?: string;
    isRequired?: boolean;
    placeholder: string;
    errorMessage?: string;
    selectedDate: DayValue;
    wrapperClassName?: string;
    showErrorMessage?: boolean;
    setSelectedDate: (val: DayValue) => void;
};

function DatePicker(props: Props) {
    const {
        label,
        isRequired,
        placeholder,
        errorMessage,
        selectedDate,
        showErrorMessage,
        wrapperClassName,
        setSelectedDate,
    } = props;

    const formatDateInput = () => {
        if (!selectedDate) return '';
        return `${selectedDate.month < 10 ?
            `0${selectedDate.month}` : selectedDate.month}-${selectedDate.day < 10 ?
                `0${selectedDate.day}` : selectedDate.day}-${selectedDate.year}`;
    };

    return (
        <div className={styles.container}>
            {label && <span className={styles.label}>{label} {isRequired && <b>*</b>}</span>}
            <div
                className={styles.custom_select}
                data-has-error={Boolean(errorMessage)}
            >
                <ModernDatePicker
                    locale="en"
                    value={selectedDate}
                    formatInputText={formatDateInput}
                    shouldHighlightWeekends
                    inputPlaceholder={placeholder}
                    onChange={(val) => setSelectedDate(val)}
                    wrapperClassName={wrapperClassName}
                    calendarSelectedDayClassName={styles.selectedDay}
                />
            </div>
            {showErrorMessage && errorMessage && (<span className={styles.error}>{errorMessage}</span>)}
        </div>
    );
};

export default DatePicker;
